/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {itemStyle, infoStyle} from '../shared/styles'
import Placeholder from '../shared/Placeholder'
import BotIcon from './BotIcon'
import UserWithoutPhotoIcon from './UserWithoutPhotoIcon'
import UserWithPhotoIcon from './UserWithPhotoIcon'
import InactiveUserIcon from './InactiveUserIcon'
import usePapiEntities from '../shared/usePapiEntities'
import {renderId, renderName, idCheck} from '../shared'
import {waitForCachedUser} from './userCache'

const renderIcon = (user, size, active) => {
    if (!active) {
        return <InactiveUserIcon size={size} />
    }

    if (user.employeeType === 'Mechanical') {
        return <BotIcon size={size} />
    }

    if (
        typeof user.profilePhotoSrc === 'undefined' ||
        user.profilePhotoSrc === null ||
        user.profilePhotoSrc.indexOf('/profile/images') > 0
    ) {
        return <UserWithoutPhotoIcon name={user.name} size={size} />
    }
    return <UserWithPhotoIcon src={user.profilePhotoSrc} size={size} />
}

const renderUser = (user, showLink, hideId, size, active) => (
    <div className="papi-item" style={itemStyle} name="RenderUser">
        {renderIcon(user, size, active)}
        <div className="item-info" style={infoStyle}>
            {renderName(user, 'users', showLink, size)}
            {renderId(user.id, hideId, size, true, 8)}
        </div>
    </div>
)

const FetchUserByIdAndRender = ({
    id,
    showLink,
    hideId,
    alwaysLoading,
    size,
    tokenProvider,
    profileApiUrl
}) => {
    const {entity, setEntity, loading, setLoading} = usePapiEntities()
    useEffect(() => {
        const fetchUser = async () => {
            if (alwaysLoading) {
                setLoading(true)
            } else if (id) {
                try {
                    setEntity(await waitForCachedUser(id, true, tokenProvider, profileApiUrl))
                    setLoading(false)
                } catch (error) {
                    console.error(error)
                    setLoading(false)
                }
            }
        }
        fetchUser()
    }, [id, alwaysLoading])
    return loading ? (
        <Placeholder />
    ) : (
        renderUser(entity, showLink, hideId, size, entity.active ?? true)
    )
}

const PapiUser = (props) => {
    const {
        id,
        user,
        showLink,
        hideId,
        alwaysLoading,
        size = 'medium',
        tokenProvider,
        profileApiUrl
    } = props
    return user ? (
        renderUser(user, showLink, hideId, size, user.active ?? true)
    ) : (
        <FetchUserByIdAndRender
            id={id}
            showLink={showLink}
            hideId={hideId}
            alwaysLoading={alwaysLoading}
            size={size}
            tokenProvider={tokenProvider}
            profileApiUrl={profileApiUrl}
        />
    )
}

PapiUser.displayName = 'PapiUser'

PapiUser.propTypes = {
    user: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        employeeType: PropTypes.string.isRequired,
        profilePhotoSrc: PropTypes.string
    }),
    id: idCheck('user'),
    showLink: PropTypes.bool,
    hideId: PropTypes.bool,
    size: PropTypes.string,
    tokenProvider: PropTypes.func,
    profileApiUrl: PropTypes.string
}

export default PapiUser
